<!--
 * @Author: xumingyang
 * @Date: 2021-01-03 02:26:24
 * @Description: 
-->
<template>
  <div class="about">
    <section class="parallax-background mobile-display background fadeIn">
      <span class="font-weight-medium white--text title-label">{{
        $t("i18n.about")
      }}</span>
    </section>
    <!--介绍-->
      <section id="introduction">
    <div class="py-8"></div>
    <v-container class="text-center" transition="slide-x-reverse-transition">
      <h3 class="font-weight-medium mb-3 item-title">{{$t('i18n.introduction')}}</h3>
      <v-divider
          style="margin-right: 30% !important;margin-left: 30% !important;"
        ></v-divider>
      <v-responsive
        class="mx-auto font-weight-regular text-justify"
        style="color: #012375;text-indent: 2em;"
      >
        <v-row>
          <v-col cols="12" md="6" class="mobile-display">
            <v-img contain height="300" src="../assets/images/about/zl.png" />
            <v-img contain height="300" src="../assets/images/about/gx.png" />
          </v-col>
          <v-col cols="12" md="6">
            <p style="font-Size:20px;color:#000;">{{$t('i18n.introductionText1')}}</p>
            <p style="font-Size:20px;color:#000;">{{$t('i18n.introductionText2')}}</p>
          </v-col>
        </v-row>
      </v-responsive>
    </v-container>
  </section>
    <!--联系方式-->
    <section id="contact-us" class="lighten-3">
    <div class="grey lighten-3"></div>
    <v-container class="text-center">
      <h3 class="font-weight-medium mb-3 item-title">{{$t('i18n.contactUs')}}</h3>
      <v-divider
          style="margin-right: 30% !important;margin-left: 30% !important;"
        ></v-divider>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <div class="font-weight-bold"><v-icon color="#0050a0">mdi-email</v-icon> {{$t('i18n.busEmail')}}
            <a href="mailto:xumingyang@iranktek.com"> {{$t('i18n.busEmailText')}}</a></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="font-weight-bold"><v-icon color="#0050a0">mdi-phone</v-icon> {{$t('i18n.busPhone')}} {{$t('i18n.busPhoneText')}}</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="font-weight-bold">
            <v-icon color="#0050a0">mdi-map-marker</v-icon> {{$t('i18n.address')}} {{$t('i18n.addressText')}}</div>
        </v-col>
      </v-row>
      <baidu-map style="margin:20px 0;height:400px" :center="center" :zoom="zoom" @ready="handler" enableScrollWheelZoom="ture" ak="3aD0HjYFcN56II3lGCmSjMScynh1pAED">
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-marker :position="center" :dragging="false" ></bm-marker>
      </baidu-map>
    </v-container>
  </section>
  </div>
</template>

<script>
import {BaiduMap, BmMarker, BmNavigation} from 'vue-baidu-map'
export default {
  name: "About",
  components: {
    BaiduMap,
    BmMarker,
    BmNavigation
  },
  data: () => ({
    center: {lng: 117.141506,lat:31.843907},
    zoom: 3
  }),
  methods: {
    handler ({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 117.210799;
      this.center.lat = 31.855621;
      this.zoom = 16
    }
  }
};
</script>
<style lang="scss" scoped>
.background{
  background:url(../assets/images/common/banner3.jpg) no-repeat;
  background-size: cover;
}
</style>
